import { FC } from 'react';

import { CampaignDeviceType } from 'utils/constants/campaign';

import useTrls from 'hooks/translation/useTrls';

const DesktopShows: FC<{ deviceType: CampaignDeviceType }> = ({ deviceType }) => {
    const trl = useTrls();

    return deviceType === CampaignDeviceType.Desktop ? <p>{trl('campaign.targetings.sources.desktopOnly')}</p> : null;
};

export default DesktopShows;
